import { countries } from "countries-list";
import { GrinEmoji, NeutralEmoji, ScreamEmoji, SmileEmoji, SpiralEmoji } from "assets/icons";

export const ORG_SET_EVENT = "ORG_SET_EVENT";

export const DEFAULT_COMPANY_NAME = "unberry";

// TODO - Temporary fix against orgId
export const ASSESSMENT_SECTION_ORG_IDS = [
  // Dev
  // "631310b7-1893-4a26-919f-ae9433d0e72e",
  // "55d87803-f999-4329-af74-f6d3dbe56f61", // DREAMT
  // Prod
  "754f36c4-e6e8-49d3-9a4b-209b39c3f5b5"
]

export const GODREJ_SECTION_IDS = [
  // Dev
  "216963a9-3a6f-49cd-bd08-853d2a370806",
  // Prod
  // "4f2faf6e-2059-4a3c-ac06-d65795222af8"
  "cbe41085-6df7-4dc6-b3d8-9a6298874161",
  "8e83e16f-d5df-4817-a090-154e5071b09a",
  "5a13fe9f-1842-4a2f-b886-e2a15443db6c",
]

export const APNA_ORG_SECTION_IDS = [
  //dev
  "77a0fbb1-2457-4421-b83a-3d7271da80de",
  //Prod
  "19d3d6b8-42e2-4c69-99f5-c0c2867ed47e"
]

export const PRE_WORKSHOP_GODREJ = "8e83e16f-d5df-4817-a090-154e5071b09a"
export const POST_WORKSHOP_GODREJ = "5a13fe9f-1842-4a2f-b886-e2a15443db6c"

export const DEFAULT_FC_TAG_LIST = ["gamecenter"];

export const COMPANY_FC_TAG_LIST = {
  DELHIVERY: "delhivery"
};

export const ORGANIZATIONS_NAME = {
  SPOTLIGHT: "Spotlight"
}

export const COUNTRY_DATA = Object.keys(countries).map((code) => {
  return ({
    ...countries[code],
    countryAbrev: code
  })
});

export const DEFAULT_COUNTRY_DATA = { ...countries["IN"], countryAbrev: "IN" };

export const LOGIN_TYPE = {
  EMAIL: "email",
  PHONE: "phone",
  THIRD_PARTY: "thirdParty"
};

export const feedbackFeelingsArray = [
  {
    key: "mind_blown",
    label: "Mind Blown",
    icon: SmileEmoji
  },
  {
    key: "happy",
    label: "Happy",
    icon: GrinEmoji
  },
  {
    key: "neutral",
    label: "Neutral",
    icon: NeutralEmoji
  },
  {
    key: "exhausted",
    label: "Exhausted",
    icon: SpiralEmoji
  },
  {
    key: "anxious",
    label: "Anxious",
    icon: ScreamEmoji
  },
]

export const DISQUALIFY_REASONS = {
  FULLSCREEN: "fullScreenExit",
  TAB_SWTCH: "tabSwitch"
}

export const PERMISSION_DEVICE_TYPES = {
  CAMERA_MIC: "camera and mic",
  CAMERA: "camera",
  MIC: "mic",
};

export const PERMISSION_ERRORS = {
  VIDEO_SOURCE: "could not start video source",
  NO_DEVICE: "requested device not found",
  PERMISSION_DENIED: "permission denied",
  PERMISSION_DENIED_BY_SYSTEM: "permission denied by system",
  CAMERA_FEED: "camera feed",
  NO_INTERNET: "no internet",
  API_FAILURE: "api failure",
}

export const SALES_TYPES_OPTIONS = {
  secured: "Yes, Secured Product (Housing Finance, LAP, MSME Lending)",
  unsecured: "Yes, Unsecured Product (Personal Loans, Used Cars, Business Loans)",
  fresher: "No, I am a Fresher"
}

export const SALES_TYPE_POSITIONS = {
  secured: process.env.REACT_APP_ENV === "development"
    ? [
      "bd5d3364-a570-4e15-bae7-14201beaa30d",
      "8b8f26ef-44fd-4296-80df-1065c66cfaac",
      "a0ede3da-c983-4c7c-9718-b035f4471638",
      "4e4c94ea-db06-466e-8c88-34226a6c12fa",
    ] : [
      "9e3b83d0-3ab2-4789-9fb4-fea458887b3d",
      "ae9b8851-b105-4197-b432-75cda6a528f7",
      "cb594aca-87dc-472e-8fe5-f631dba13866",
      "868556cd-c2bb-48ec-81dd-51c296d6d8d5",
    ],
  unsecured: process.env.REACT_APP_ENV === "development"
    ? [
      "bf72ca4d-3c60-4838-bf37-52106af42228",
      "5479a9d5-f62a-4471-91f1-c0f6aa75de4d",
      "0b25be35-ca8a-4be1-bc35-f85fef9bb73d",
      "0d7d08a6-b73d-4bee-b4b5-831596529a62",
    ]
    : [
      "e22eb97d-3850-4a12-ad5d-18a7ecd95f6f",
      "7cab33ca-bb56-4b74-9d1f-29e0d69b1f78",
      "3b81d814-86c7-4f33-9fb9-8abf6ed4296f",
      "bc6f2257-abf2-4d3d-a5d3-bc27971fb50f",
    ],
  fresher: process.env.REACT_APP_ENV === "development"
    ? ["6ff99e7c-18bf-4890-993d-3aa57280d876"]
    : ["d7e3eabb-a50e-4989-960c-4551fb015d6c"],
}

export const PROCTORING_TYPES = {
  VIDEO: "user",
}